'use strict';

angular.module('atex.art').controller('ArtAboutCtrl',
['$scope', '$location', 'ArtVersionService',

  function($scope, $location, ArtVersionService) {
    $scope.applicationVersion = '';

    ArtVersionService.getVersion().then(function(version) {
      $scope.applicationVersion = version;
    }, function(error) {
      console.log('Error while reading application version:', error);
    });

    $scope.goBack = function() {
      $location.path('/');
    };
  }
]);
